import moment from 'moment'
const bigdecimal = require('bigdecimal')

export const saveDataLocal = (key, data) => {
  localStorage.setItem(key, JSON.stringify(data))
}
export const getDataLocal = (key) => {
  return JSON.parse(localStorage.getItem(key))
}

export const removeDataLocal = (key) => {
  localStorage.removeItem(key)
}

export const isObject = (value) => {
  return value && typeof value === 'object' && value.constructor === Object
}

export const roundingNumber = (number, rounding = 8) => {
  const powNumber = Math.pow(10, parseInt(rounding))
  return Math.floor(number * powNumber) / powNumber
}

export const numberWithCommasInt = (strNumber) => {
  return strNumber ? strNumber.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') : 0
}

export const formatNumberDisplay = (strNumber, decimalFormat = 8) => {
  let first = '0'
  let second = ''
  decimalFormat = decimalFormat < 8 ? decimalFormat : 8
  isNaN(Number(strNumber)) && (strNumber = 0)
  strNumber = Number(strNumber).toFixed(10)
  let arrDigit = String(strNumber).split('.')
  if (arrDigit.length > 1 && decimalFormat > 0) {
    first = numberWithCommasInt(arrDigit[0])
    second = arrDigit[1].substring(0, decimalFormat).replace(/\.?0+$/, '')
  } else {
    first = numberWithCommasInt(arrDigit[0])
  }
  return {
    firstNumber: first,
    secondNumber: second
  }
}

export const formatFiatDisplay = (strNumber, decimalFormat = 6) => {
  let first = '0'
  let second = '00'
  decimalFormat = decimalFormat < 6 ? decimalFormat : 6
  isNaN(Number(strNumber)) && (strNumber = 0)
  strNumber = Number(strNumber).toFixed(10)
  let arrDigit = String(strNumber).split('.')
  if (arrDigit.length > 1) {
    first = numberWithCommasInt(arrDigit[0])
    second = arrDigit[1].substring(0, decimalFormat).replace(/\.?0+$/, '')
  } else {
    first = numberWithCommasInt(arrDigit[0])
  }
  return {
    firstNumber: first,
    secondNumber: second
  }
}

export const formatPriceDisplay = (strNumber, decimalFormat = 8) => {
  let first = '0'
  let second = ''
  decimalFormat = decimalFormat < 8 ? decimalFormat : 8
  isNaN(Number(strNumber)) && (strNumber = 0)
  strNumber = Number(strNumber).toFixed(10)
  let arrDigit = String(strNumber).split('.')
  if (arrDigit.length > 1 && decimalFormat > 0) {
    first = arrDigit[0]
    second = arrDigit[1].substring(0, decimalFormat).replace(/\.?0+$/, '')
    if (second.length === 0) {
      second = '00'
    } else if (second.length === 1) {
      second = second + '0'
    }
  } else {
    first = arrDigit[0]
  }
  return {
    firstNumber: first,
    secondNumber: second
  }
}

export const validateNumber = (strNumber) => {
  const reg = /^[0-9]+(\.)?[0-9]*$/
  return reg.test(strNumber)
}

export const validateEmail = (strEmail) => {
  const reg = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i
  return reg.test(strEmail)
}

export const countDots = (strString, strLetter) => {
  return (String(strString).match(RegExp(strLetter, 'g')) || []).length
}

export const copyText = (data) => {
  let textField = document.createElement('textarea')
  textField.innerText = data
  document.body.appendChild(textField)
  textField.select()
  document.execCommand('copy')
  textField.remove()
}

export const convertSmallNumberToRegular = (x) => {
  if (Math.abs(x) < 1.0) {
    let e = parseInt(x.toString().split('e-')[1])
    if (e) {
      x *= Math.pow(10, e - 1)
      x = '0.' + (new Array(e)).join('0') + x.toString().substring(2)
    }
  } else {
    let e = parseInt(x.toString().split('+')[1])
    if (e > 20) {
      e -= 20
      x /= Math.pow(10, e)
      x += (new Array(e + 1)).join('0')
    }
  }
  return x
}

export const convertBalanceToWei = (strValue, iDecimal = 18) => {
  var multiplyNum = new bigdecimal.BigDecimal(Math.pow(10, iDecimal))
  var convertValue = new bigdecimal.BigDecimal(String(strValue))
  return multiplyNum.multiply(convertValue).toString().split('.')[0]
}

export const convertWeiToBalance = (strValue, iDecimal = 18) => {
  var multiplyNum = new bigdecimal.BigDecimal(Math.pow(10, iDecimal))
  var convertValue = new bigdecimal.BigDecimal(String(strValue))
  return convertValue.divide(multiplyNum).toString()
}

export const convertTimestampToDate = (strTimestamp) => {
  let strTime = '--:--'
  if (strTimestamp) {
    if (String(strTimestamp).length > 10) {
      strTime = moment(strTimestamp).format('YYYY.MM.DD')
    } else {
      strTime = moment(strTimestamp * 1000).format('YYYY.MM.DD')
    }
  }
  return strTime
}

export const scientificToDecimal = (num) => {
  const sign = Math.sign(num)
  // if the number is in scientific notation remove it
  if (/\d+\.?\d*e[\+\-]*\d+/i.test(num)) {
    const zero = '0'
    const parts = String(num).toLowerCase().split('e') // split into coeff and exponent
    const e = parts.pop() // store the exponential part
    let l = Math.abs(e) // get the number of zeros
    const direction = e / l // use to determine the zeroes on the left or right
    const coeffArray = parts[0].split('.')

    if (direction === -1) {
      coeffArray[0] = Math.abs(coeffArray[0])
      num = zero + '.' + new Array(l).join(zero) + coeffArray.join('')
    } else {
      const dec = coeffArray[1]
      if (dec) l = l - dec.length
      num = coeffArray.join('') + new Array(l + 1).join(zero)
    }
  }

  if (sign < 0) {
    num = -num
  }

  return num
}

export const removeDuplicateObjectByKey = (arr, key) => {
  const unique = arr
    .map(e => e[key].toString())

    // store the keys of the unique objects
    .map((e, i, final) => final.indexOf(e) === i && i)

    // eliminate the dead keys & store unique objects
    .filter(e => arr[e]).map(e => arr[e])

  return unique
}

export const getCurrentBrowserLanguage = () => {
  let language = navigator.language
  switch (language) {
  case 'en-US':
  case 'en':
    language = 'en'
    break
  case 'ja-JP':
  case 'ja':
  case 'jp':
    language = 'jp'
    break
  default:
    language = 'en'
    break
  }
  return language
}